import React from 'react';

export default function HomePage() {
  return (
    <div>
      <h1>Home</h1>
      <p>Your AI-powered executive assistant at your service.</p>
      <p>Check your instructions, automations, and inbox!</p>
    </div>
  );
}
